(function () {
  var configEl = document.getElementById('snr-live-fish-fee-config');
  if (!configEl) return;

  var config = JSON.parse(configEl.textContent);
  var FEE_VARIANT_ID = Number(config.feeVariantId);
  var FEE_HANDLE = config.feeHandle || 'styrofoam-box';
  var LIVE_FISH_COLLECTION = config.liveFishCollectionHandle || 'all-live-fish';
  var LIVE_FISH_IDS = new Set(
    (config.liveFishProductIds || [])
      .map(function (id) {
        return Number(id);
      })
      .filter(function (id) {
        return !Number.isNaN(id) && id > 0;
      })
  );
  var syncing = false;
  var pendingSync = null;
  var lastHandledState = '';
  var idsLoaded = false;

  function isFeeItem(item) {
    return Number(item.variant_id) === FEE_VARIANT_ID || item.handle === FEE_HANDLE;
  }

  function cartHasLiveFish(cart) {
    return cart.items.some(function (item) {
      if (isFeeItem(item)) return false;
      return LIVE_FISH_IDS.has(Number(item.product_id));
    });
  }

  function cartHasFee(cart) {
    return cart.items.some(isFeeItem);
  }

  function getStateKey(cart) {
    var feeQty = 0;
    cart.items.forEach(function (item) {
      if (isFeeItem(item)) feeQty += item.quantity;
    });
    return cartHasLiveFish(cart) + '|' + cartHasFee(cart) + '|' + feeQty + '|' + cart.item_count;
  }

  function getFeeLineIndexes(cart) {
    var lines = [];
    for (var i = 0; i < cart.items.length; i++) {
      if (isFeeItem(cart.items[i])) lines.push(i + 1);
    }
    return lines;
  }

  function getCartItemsElement() {
    return document.querySelector('cart-drawer cart-items') || document.querySelector('cart-items');
  }

  function getSectionsToBundle() {
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    var drawerSectionId = document.getElementById('CartDrawer')?.dataset?.sectionId;
    if (drawerSectionId && sectionsToBundle.indexOf(drawerSectionId) === -1) {
      sectionsToBundle.push(drawerSectionId);
    }

    return sectionsToBundle;
  }

  function publishCartUpdate(cartData) {
    if (!cartData) return;

    var event = { cart: cartData };
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, event);
    }

    var cartItems = getCartItemsElement();
    if (cartItems && typeof cartItems.onCartUpdate === 'function') {
      try {
        cartItems.onCartUpdate(event);
      } catch (error) {
        console.warn('SNR live fish fee cart update failed:', error);
      }
    }
  }

  function refreshCartDrawer() {
    var cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer && typeof cartDrawer.onCartRefresh === 'function') {
      cartDrawer.onCartRefresh(new CustomEvent('cart:refresh', { detail: {} }));
    }
  }

  function applyCartResponse(parsedState) {
    return fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cartJson) {
        if (parsedState && parsedState.sections) {
          cartJson.sections = parsedState.sections;
        }
        publishCartUpdate(cartJson);
        return cartJson;
      });
  }

  function finishSync(delay) {
    window.setTimeout(function () {
      syncing = false;
      fetch('/cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          lastHandledState = getStateKey(cart);
          scheduleSync(cart);
        })
        .catch(function () {
          /* ignore */
        });
    }, delay || 500);
  }

  function addMissingFee() {
    if (syncing || !FEE_VARIANT_ID) return;

    syncing = true;
    var sectionsToBundle = getSectionsToBundle();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: FEE_VARIANT_ID, quantity: 1 }],
        sections: sectionsToBundle,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (parsedState) {
        if (parsedState.status && parsedState.status >= 400) {
          throw new Error(parsedState.description || parsedState.message || 'Unable to add live fish packaging fee');
        }
        return applyCartResponse(parsedState);
      })
      .catch(function (error) {
        console.warn('SNR live fish fee add failed:', error);
        refreshCartDrawer();
      })
      .finally(function () {
        finishSync(700);
      });
  }

  function removeFeeLine(line) {
    var cartItems = getCartItemsElement();
    if (cartItems && typeof cartItems.updateQuantity === 'function') {
      cartItems.updateQuantity(line, 0);
      return Promise.resolve();
    }

    var sectionsToBundle = getSectionsToBundle();
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        line: line,
        quantity: 0,
        sections: sectionsToBundle,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (parsedState) {
        return applyCartResponse(parsedState);
      });
  }

  function removeOrphanFee(cart) {
    var lines = getFeeLineIndexes(cart);
    if (!lines.length) return;

    syncing = true;
    removeFeeLine(lines[0])
      .catch(function (error) {
        console.warn('SNR live fish fee remove failed:', error);
        refreshCartDrawer();
      })
      .finally(function () {
        finishSync(700);
      });
  }

  function enforceSingleFee(cart) {
    var feeLines = getFeeLineIndexes(cart);
    if (!feeLines.length) return;

    var feeItem = cart.items[feeLines[0] - 1];
    var extraLines = feeLines.slice(1);
    var needsQtyFix = feeItem && feeItem.quantity !== 1;

    if (!extraLines.length && !needsQtyFix) {
      lastHandledState = getStateKey(cart);
      return;
    }

    syncing = true;
    var task = Promise.resolve();

    if (needsQtyFix) {
      var cartItems = getCartItemsElement();
      if (cartItems && typeof cartItems.updateQuantity === 'function') {
        cartItems.updateQuantity(feeLines[0], 1);
      } else {
        task = fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            line: feeLines[0],
            quantity: 1,
            sections: getSectionsToBundle(),
            sections_url: window.location.pathname,
          }),
        }).then(function (response) {
          return response.json();
        });
      }
    }

    extraLines.forEach(function (line) {
      task = task.then(function () {
        return removeFeeLine(line);
      });
    });

    task
      .catch(function (error) {
        console.warn('SNR live fish fee normalize failed:', error);
        refreshCartDrawer();
      })
      .finally(function () {
        finishSync(700);
      });
  }

  function scheduleSync(cart) {
    if (!cart || !cart.items || syncing) return;
    if (!idsLoaded && LIVE_FISH_IDS.size === 0) return;

    var stateKey = getStateKey(cart);
    if (stateKey === lastHandledState) return;

    clearTimeout(pendingSync);
    pendingSync = window.setTimeout(function () {
      fetch('/cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (freshCart) {
          if (syncing) return;

          var hasLiveFish = cartHasLiveFish(freshCart);
          var hasFee = cartHasFee(freshCart);

          if (hasLiveFish && !hasFee) {
            addMissingFee();
          } else if (!hasLiveFish && hasFee) {
            removeOrphanFee(freshCart);
          } else if (hasLiveFish && hasFee) {
            enforceSingleFee(freshCart);
          } else {
            lastHandledState = getStateKey(freshCart);
          }
        })
        .catch(function () {
          /* ignore cart read errors */
        });
    }, 250);
  }

  function fetchCollectionProductIds(handle) {
    var ids = [];

    function fetchPage(page) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          (data.products || []).forEach(function (product) {
            ids.push(Number(product.id));
          });

          if ((data.products || []).length === 250) {
            return fetchPage(page + 1);
          }

          return ids;
        });
    }

    return fetchPage(1);
  }

  function loadLiveFishIds() {
    return fetchCollectionProductIds(LIVE_FISH_COLLECTION)
      .then(function (ids) {
        ids.forEach(function (id) {
          if (!Number.isNaN(id) && id > 0) {
            LIVE_FISH_IDS.add(id);
          }
        });
        idsLoaded = true;
      })
      .catch(function () {
        idsLoaded = true;
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      var removeEl = event.target.closest('[is="cart-remove-item"]');
      if (!removeEl) return;

      var cartItem = removeEl.closest('[data-snr-fee-locked="true"]');
      if (!cartItem) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  function handleCartChange(cart) {
    if (cart) {
      scheduleSync(cart);
      return;
    }

    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(scheduleSync)
      .catch(function () {
        /* ignore */
      });
  }

  if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.cart) handleCartChange(event.cart);
    });
  }

  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.cart) handleCartChange(event.detail.cart);
  });

  document.addEventListener('product-ajax:added', function () {
    handleCartChange(null);
  });

  function isCheckoutLink(link) {
    if (!link || !link.getAttribute) return false;
    var href = link.getAttribute('href') || '';
    return href === '/checkout' || href.indexOf('/checkout?') === 0;
  }

  function ensureFeeBeforeCheckout() {
    return loadLiveFishIds().then(function () {
      return fetch('/cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          if (!cartHasLiveFish(cart) || cartHasFee(cart)) {
            return cart;
          }

          return new Promise(function (resolve, reject) {
            syncing = true;
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({
                items: [{ id: FEE_VARIANT_ID, quantity: 1 }],
              }),
            })
              .then(function (response) {
                return response.json();
              })
              .then(function (parsedState) {
                if (parsedState.status && parsedState.status >= 400) {
                  throw new Error(parsedState.description || parsedState.message || 'Unable to add packaging fee');
                }
                return fetch('/cart.js').then(function (response) {
                  return response.json();
                });
              })
              .then(resolve)
              .catch(reject)
              .finally(function () {
                syncing = false;
              });
          });
        });
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a[href]');
      if (!link || !isCheckoutLink(link)) return;

      event.preventDefault();
      event.stopPropagation();

      ensureFeeBeforeCheckout()
        .then(function () {
          window.location.href = link.href;
        })
        .catch(function (error) {
          console.warn('SNR live fish fee checkout guard failed:', error);
          window.location.href = link.href;
        });
    },
    true
  );

  loadLiveFishIds().then(function () {
    return fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(scheduleSync)
      .catch(function () {
        /* ignore initial cart read errors */
      });
  });
})();
